import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-warning" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    class: "confirmCreditModal",
    title: "请认证企业",
    "ok-text": "去认证",
    onOk: _ctx.onOk
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_app_icon, { type: "warning" }),
          _createTextVNode(" 员工人数已达上限( " + _toDisplayString(_ctx.enterprise.killNum) + " )人", 1)
        ]),
        _createTextVNode(),
        _hoisted_2,
        _createTextVNode(" 请完成企业认证后继续添加更多员工 ")
      ])
    ]),
    _: 1
  }, 8, ["visible", "onOk"]))
}